export default __webpack_public_path__ + "static/media/th.4c5c8a5f.svg";